function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.8958 11.3682C32.6497 8.12007 28.3326 6.32936 23.7336 6.32739C14.2535 6.32739 6.54049 14.0365 6.53852 23.5126C6.53457 26.528 7.3254 29.4922 8.83212 32.1052L6.39258 41.0114L15.5078 38.6212C18.0302 39.9938 20.8543 40.7136 23.7257 40.7136H23.7336C33.2097 40.7136 40.9228 33.0026 40.9267 23.5264C40.9287 18.9353 39.1419 14.6183 35.8958 11.3682Z",
  stroke: "#174EA6",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8203 26.7437L26.621 25.9489C27.3566 25.2192 28.5202 25.1265 29.3682 25.7221C30.1886 26.298 30.9301 26.8147 31.6204 27.2959C32.7169 28.0571 32.849 29.619 31.9044 30.5617L31.1964 31.2697",
  stroke: "#174EA6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0605 16.1294L16.7685 15.4214C17.7112 14.4787 19.2732 14.6109 20.0344 15.7054C20.5136 16.3957 21.0303 17.1372 21.6082 17.9576C22.2038 18.8056 22.113 19.9692 21.3814 20.7048L20.5866 21.5055",
  stroke: "#174EA6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2047 31.2673C28.2839 34.1742 23.3753 31.7051 19.5 27.8279",
  stroke: "#174EA6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5006 27.8358C15.6254 23.9585 13.1562 19.0518 16.0632 16.1311",
  stroke: "#174EA6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5918 21.5112C21.2209 22.5032 22.0275 23.4853 22.9386 24.3965L22.9426 24.4004C23.8537 25.3115 24.8358 26.1182 25.8278 26.7473",
  stroke: "#174EA6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp.95ab68bb.svg";
export { ForwardRef as ReactComponent };